import { useCallback, useState } from 'react'

// Drives PhotoViewer from a thumbnail grid: each thumbnail carries its rank in a
// Data-viewer-index attribute, and a null index means the viewer is closed.
const usePhotoViewer = () => {
  const [openIndex, setOpenIndex] = useState(null)

  const handleThumbClick = useCallback(event => {
    setOpenIndex(Number(event.currentTarget.dataset.viewerIndex))
  }, [])
  const onClose = useCallback(() => setOpenIndex(null), [])

  return {
    handleThumbClick,
    viewerProps: { isOpen: openIndex !== null, startIndex: openIndex ?? 0, onClose }
  }
}

export default usePhotoViewer
